import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CrossButton } from 'src/components/CrossButton/CrossButton';
import { withDefaults } from '../../../../utils/withDefaults';
export const Root = styled(Box)(({
  theme
}) => ({
  padding: theme.spacing(2),
  boxShadow: theme.shadows[3],
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.common.white
}));
const WrapperRoot = styled(Box)({
  justifyContent: 'space-between'
});
export const Wrapper = withDefaults(WrapperRoot, {
  display: 'flex',
  gap: 2
});
export const Header = styled(Box)(({
  theme,
  headerStyles
}) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
  flex: 1,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  ...headerStyles
}));
export const CloseButton = styled(CrossButton)({
  padding: 0
});